import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Banner from '@src/pc/index/layout/components/Banner';
import Chip from 'Chip';
import Swiper, { Pagination, Autoplay } from 'swiper';
import { Player } from '@ifeng-fe/three_terminal/es/pc/video';
import { ChipMap } from '../../chipMap';
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';

Swiper.use([Pagination, Autoplay]);

class MediaNews extends PureComponent {

    static propTypes = {
        content: PropTypes.object
    };

    state = {
        swiperIndex: 0,
        videoIndex: 0
    }

    componentDidMount() {
        // eslint-disable-next-line consistent-this
        const that = this;

        new Swiper('#swiper1', {
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            pagination: {
                el: '.pagination1',
                clickable: true
            },
            on: {
                slideChangeTransitionEnd () {
                    that.setState({
                        swiperIndex: this.realIndex
                    });
                }
            }
        });
    }

    setVideoIndex = (index) => {
        this.setState({
            videoIndex: index
        });
    }

    render() {
        const { content } = this.props;
        const { swiperIndex, videoIndex } = this.state;

        return (
            <div className={styles.mediaNews}>
                <Chip key="Banner1" {...ChipMap.Banner1}>
                    <Banner type="small" title={content.Banner1} />
                </Chip>

                <Chip key="Swiper1" {...ChipMap.Swiper1}>
                    <div className={styles.swiperWp}>
                        <div className="swiper" id="swiper1">
                            <div className="swiper-wrapper">
                                {
                                    content.Swiper1.map((item, index) => {
                                        return (
                                            <div className="swiper-slide" key={index}>
                                                <div className={styles.swiperItem}>
                                                    <a href={item.url} target="_blank">
                                                        <img src={formatImage(getThumbnail(item), 303, 208)} />
                                                    </a>
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                        <div className={styles.textPart}>
                            {content.Swiper1[swiperIndex].title}
                            <div className="pagination1" />
                        </div>
                    </div>
                </Chip>

                <Chip key="Banner2" {...ChipMap.Banner2}>
                    <Banner type="small" title={content.Banner2} style={{ marginTop: '30px' }} />
                </Chip>

                <Chip key="VideoList" {...ChipMap.VideoList}>
                    <div>
                        <Player
                            key={videoIndex}
                            videoConfig={{
                                title: content.VideoList[videoIndex].title,
                                posterUrl: content.VideoList[videoIndex].posterUrl,
                                videoPlayUrl: content.VideoList[videoIndex].videoPlayUrl
                            }}
                            playermsg={{
                                // 播放器宽
                                width: 323,
                                // 播放器高
                                height: 240,
                                // 是否自动播放
                                autoPlay: false,
                                // 是否显示播放控件
                                controls: true,
                            }}
                        />
                        <div className={styles.videoList}>
                            {
                                content.VideoList.map((item, index) => {
                                    return (
                                        <div key={index} onClick={() => this.setVideoIndex(index)}>
                                            <img src={require('../../assets/video.png')} alt="" />
                                            {item.title}
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </Chip>
            </div>
        );
    }
}

export default MediaNews;
